module.exports = __webpack_public_path__ + "img/Certificate-of-Diploma.58728b04.png";